import { Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { first } from 'rxjs/operators';

import { ListEntryTypes } from '@site-mate/dashpivot-shared-library';

import { TmpI18NService } from 'app/i18n/tmp-i18n.service';

@Component({
  selector: 'cc-list-property-kind',
  templateUrl: './list-property-kind.component.html',
  styleUrls: ['./list-property-kind.component.scss'],
})
export class ListPropertyKindComponent implements OnInit {
  public readonly listEntryTypes = ListEntryTypes;

  @Input() editable = true;
  @Input() propertyKind: ListEntryTypes | null;
  @Output() propertyKindChange = new EventEmitter<ListEntryTypes>();
  @ViewChild('selectPropertyKindButton') selectPropertyKindButton: ElementRef<HTMLButtonElement>;

  selectedKindIconClass = 'cc-icon cc-icon-text';
  private readonly iconKindDictionary = {
    text: 'text',
    number: 'number',
    date: 'calendar',
    'date-expiry': 'calendar',
    attachment: 'attachment',
    default: 'text',
  };
  propertyKindWarning: string;

  constructor(private readonly i18nService: TmpI18NService, private readonly zone: NgZone) {}

  ngOnInit() {
    this.propertyKindWarning = this.i18nService.getMessage('listPropertyKindWarning');
    this.selectedKindIconClass = `cc-icon cc-icon-${this.iconKindDictionary[this.propertyKind || 'default']}`;
    this.openMenuIfEditable();
  }

  private openMenuIfEditable() {
    if (this.editable) {
      this.zone.onStable.pipe(first()).subscribe(() => {
        this.selectPropertyKindButton.nativeElement.focus();
        this.selectPropertyKindButton.nativeElement.dispatchEvent(
          new Event('focusin', { bubbles: true, cancelable: true }),
        );
        this.selectPropertyKindButton.nativeElement.click();
      });
    }
  }

  selectKind(kind: ListEntryTypes) {
    this.propertyKindChange.emit(kind);
    this.selectedKindIconClass = `cc-icon cc-icon-${this.iconKindDictionary[kind]}`;
  }
}
